import apiClient from './apiClient';
import {
  CREATE_MENU,
  DELETE_MENU,
  DOWNLOAD_MENU,
  EDIT_MENU,
  GET_MENU_DETAIL,
  HIDE_SHOW_MENU,
  REORDER_MENUS
} from '../constants/UriConstants';
import {
  CreateMenuInterface,
  CreateMenuResponse,
  DetailedMenuInterface,
  EditMenuInterface,
  EditMenuResponse,
  LocationScope
} from '../types/MenuInterface';
import { buildLocationScopeBody } from '../utils/locationScope';

export const createMenu = (
  menu: CreateMenuInterface,
  locationScope: LocationScope = 'single',
  restaurantIDs: number[] = []
): Promise<CreateMenuResponse> =>
  apiClient
    .post(CREATE_MENU, { menus: [menu], ...buildLocationScopeBody(locationScope, restaurantIDs) })
    .then((response) => response.data);

export const deleteMenu = async (menuID: number) => {
  await apiClient.delete(DELETE_MENU + menuID);
};

export const downloadMenu = (menuID: number, fileFormat: 'pdf' | 'docx'): Promise<{ fileURL: string }> =>
  apiClient.post(DOWNLOAD_MENU, { menuID, fileFormat }).then((response) => response.data);

export const editMenu = (
  menu: EditMenuInterface,
  locationScope: LocationScope = 'single',
  restaurantIDs: number[] = []
): Promise<EditMenuResponse> =>
  apiClient
    .put(EDIT_MENU, { ...menu, ...buildLocationScopeBody(locationScope, restaurantIDs) })
    .then((response) => response.data);

export const getMenuDetails = (menuID: number): Promise<DetailedMenuInterface> =>
  apiClient.get(GET_MENU_DETAIL + menuID).then((response) => response.data);

export const hideMenu = async (menuID: number) => {
  await apiClient.put(HIDE_SHOW_MENU, { menuID, hide: true });
};

export const reorderMenus = async (menusOrder: number[]) => {
  await apiClient.patch(REORDER_MENUS, { menusOrder });
};

export const showMenu = async (menuID: number) => {
  await apiClient.put(HIDE_SHOW_MENU, { menuID, hide: false });
};
